import {
  chakra,
  forwardRef,
  HTMLChakraProps,
  useMultiStyleConfig,
} from '@chakra-ui/system';
import { cx } from '@chakra-ui/utils';

import { usePercentageBreakdownContext } from './context';

export const PercentageBreakdownBarSegment = forwardRef<
  HTMLChakraProps<'div'>,
  'div'
>(({ className, ...props }, ref) => {
  const { size, variant } = usePercentageBreakdownContext();
  const styles = useMultiStyleConfig('PercentageBreakdown', { size, variant });
  const _className = cx('percentage-breakdown__bar-segment', className);

  return (
    <chakra.div
      __css={styles.barSegment}
      className={_className}
      {...props}
      ref={ref}
    />
  );
});
